/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__badge_motorcycle = /** @type {(inputs: {}) => string} */ () => {
	return `Motorrad`
};

const en_bookmark__badge_motorcycle = /** @type {(inputs: {}) => string} */ () => {
	return `Motorcycle`
};

const es_bookmark__badge_motorcycle = /** @type {(inputs: {}) => string} */ () => {
	return `Moto`
};

const fr_bookmark__badge_motorcycle = /** @type {(inputs: {}) => string} */ () => {
	return `Moto`
};

const it_bookmark__badge_motorcycle = /** @type {(inputs: {}) => string} */ () => {
	return `Motocicletta`
};

const nl_bookmark__badge_motorcycle = /** @type {(inputs: {}) => string} */ () => {
	return `Motor`
};

const pt_bookmark__badge_motorcycle = /** @type {(inputs: {}) => string} */ () => {
	return `Motociclo`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_motorcycle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__badge_motorcycle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__badge_motorcycle", locale)
	if (locale === "de") return de_bookmark__badge_motorcycle(inputs)
	if (locale === "en") return en_bookmark__badge_motorcycle(inputs)
	if (locale === "es") return es_bookmark__badge_motorcycle(inputs)
	if (locale === "fr") return fr_bookmark__badge_motorcycle(inputs)
	if (locale === "it") return it_bookmark__badge_motorcycle(inputs)
	if (locale === "nl") return nl_bookmark__badge_motorcycle(inputs)
	return pt_bookmark__badge_motorcycle(inputs)
};